
















































import {Component, Vue} from 'vue-property-decorator';
import Menu from './Menu';
import {State} from "vuex-class";


@Component
export default class Sidebar extends Vue {
  menu = Menu;
  @State menuCollapsed;
}
